import { Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { WizardPage } from '../../../../general/components/wizard-page';
import { RootState } from '../../../../store';
import { nextStep } from '../../../application/reducers/next-step';
import { BankFetchingIcon } from '../../icons';

const selectVerifyRevenueConfig = (state: RootState) => state.config.config?.verifyRevenue;

const FetchingMxBankDataPage: React.FC = () => {
  const config = useSelector(selectVerifyRevenueConfig);
  const pollInterval = (config?.pollSeconds || 2) * 1000;
  const dispatch = useDispatch();
  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(nextStep({ gotoNextPage: true }));
    }, pollInterval);
    return () => {
      clearInterval(interval);
    };
  }, [dispatch, pollInterval]);

  return (
    <WizardPage title="" icon={<BankFetchingIcon />}>
      <Typography variant="body1" align="center" mb={2}>
        Fetching your bank data
      </Typography>
      <Typography variant="inherit" align="center">
        <>
          Please wait while we fetch data from your bank.
          <br />
          This can take up to {config?.maxWaitSeconds} seconds.
        </>
      </Typography>
    </WizardPage>
  );
};

export { FetchingMxBankDataPage };
